var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetain4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 271.281,
    height: 285.728,
    viewBox: "0 0 271.281 285.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.254,
    x2: 0.746,
    y1: -8.581,
    y2: -8.581,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2bc5b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2bc5b4",
    stopOpacity: 0.471
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2.736,
    x2: -1.736,
    y1: -15.317,
    y2: -15.317,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#24afa0}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7237",
    transform: "translate(-974.243 -937.454)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_383",
    cx: 57.073,
    cy: 57.073,
    r: 57.073,
    fill: "url(#linear-gradient)",
    opacity: 0.3,
    transform: "translate(974.32 1065.329)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_384",
    cx: 36.783,
    cy: 36.783,
    r: 36.783,
    fill: "url(#linear-gradient-2)",
    opacity: 0.3,
    transform: "translate(1144.267 1062.989)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7236",
    transform: "translate(974.243 937.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3200",
    d: "M1100.792 947.823c0 1.4.03 2.855 0 4.306-.244 10.052-7.349 17.064-17.43 17.086q-26.347.058-52.693 0c-10.631-.014-17.7-7.079-17.778-17.691-.009-1.243 0-2.487 0-3.894-6.936 0-13.583-.335-20.175.116-4.51.309-8.016 4.779-8.459 9.449-.1 1.05-.06 2.115-.06 3.172v212.042c0 8.409 3.27 11.64 11.723 11.64h121.893c8.46 0 11.69-3.227 11.7-11.681 0-1.482-.056-2.966.019-4.443.155-3.069 2.172-5.11 4.943-5.093s4.823 2.039 4.852 5.157c.08 8.676.035 17.353.035 26.029 0 3.068.084 6.141-.034 9.2a20.465 20.465 0 0 1-20.307 19.9q-62.216.115-124.432 0c-11.116-.022-19.864-8.948-20.325-20.282-.03-.74-.011-1.481-.011-2.222V959.686c0-11.479 6.648-19.97 17.173-21.913a24.477 24.477 0 0 1 4.42-.307q60.946-.024 121.892-.009c12.765 0 21.556 8.763 21.616 21.506q.051 10.792 0 21.585c-.014 3.891-1.787 6.117-4.823 6.184-3.114.07-5-2.285-5.014-6.323-.016-7.089.025-14.179-.015-21.268-.042-7.3-4.375-11.675-11.636-11.737-5.29-.045-10.58.011-15.87.04a5.566 5.566 0 0 0-1.204.379zm28.555 245.211c-6.073.327-12.008.911-17.944.926q-54.873.128-109.747 0c-5.727-.013-11.453-.6-17.467-.943 0 .942.118 2.712-.019 4.463-.885 11.38 3.69 16 15.895 15.877 38.482-.375 76.97-.138 115.455-.139 1.163 0 2.328.029 3.488-.031 5.307-.274 9.673-3.853 10.252-9.068a95.144 95.144 0 0 0 .087-11.085zm-106.275-245.489c-.867 9.414 1.212 11.758 10.049 11.757 16.171 0 32.345-.211 48.51.1 6.793.13 10.756-3.627 8.728-11.854z",
    className: "cls-3",
    transform: "translate(-974.243 -937.454)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3201",
    d: "M1127.7 1226.168h-85.683c-10.528 0-15.96-5.473-15.964-16.057 0-6.664-.023-13.329.009-19.993.02-4.1 1.527-5.648 5.685-5.989 6.017-.493 10.362-3.462 12.8-8.967 2.534-5.714 1.188-11.033-2.4-15.785-2.518-3.335-6.383-4.321-10.354-4.8-4.478-.538-5.724-1.859-5.737-6.267-.02-7.087-.044-14.175.005-21.262.059-8.55 6.027-14.563 14.637-14.567q87.111-.048 174.222 0c8.759 0 14.7 5.981 14.807 14.788.079 6.557.017 13.117.018 19.675 0 5.949-.7 6.919-6.711 7.716a14.379 14.379 0 0 0-11.44 7.99 14.764 14.764 0 0 0 11.759 21.444c5.147.49 6.382 1.828 6.39 6.984.01 6.559.026 13.117-.005 19.676-.045 9.669-5.76 15.405-15.405 15.411q-43.312.025-86.633.003zm33.621-103.6c-.842-.062-1.357-.133-1.872-.133q-59.187-.008-118.374.007c-3.658 0-5.1 1.5-5.157 5.283-.063 4.336.308 8.7-.088 13-.315 3.423 1.2 4.743 4.031 5.892 7.79 3.156 13.029 8.482 14.973 17.065 2.81 12.408-3.564 24.684-15.568 28.965-1.079.385-2.164.755-3.361 1.172 0 5.418-.01 10.7 0 15.986.012 5.364 1.17 6.528 6.52 6.529q57.759.009 115.519 0c1.107 0 2.215-.091 3.373-.141zm10.205 93.322c.478.216.664.372.851.373 14.272.031 28.545.092 42.817.035 3.066-.012 4.519-1.707 4.558-4.894.059-4.863-.134-9.734.081-14.588.109-2.455-.711-3.352-3.038-4.113a23.973 23.973 0 0 1-16.675-24c.579-10.786 6.444-19.761 17.668-22.927 1.8-.508 2.012-1.428 2-2.94-.047-4.863 0-9.727-.018-14.591-.014-4.51-1.314-5.809-5.864-5.813q-19.666-.017-39.333 0h-3.045z",
    className: "cls-3",
    transform: "translate(-996.502 -1012.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    d: "M1194.539 1049.237h-94.242a19.453 19.453 0 0 1-3.167-.085 4.888 4.888 0 0 1-.181-9.655 16.084 16.084 0 0 1 3.159-.163q94.56-.01 189.12 0a23.917 23.917 0 0 1 2.536.056 4.916 4.916 0 0 1-.128 9.829c-.947.07-1.9.023-2.855.023z",
    className: "cls-3",
    transform: "translate(-1025.24 -981.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    d: "M1164.7 1074.381h94.239a14.868 14.868 0 0 1 3.162.112 4.6 4.6 0 0 1 3.982 4.653 4.517 4.517 0 0 1-3.645 4.9 14.211 14.211 0 0 1-3.458.262q-94.716.016-189.43.005a16.472 16.472 0 0 1-2.845-.122 4.735 4.735 0 0 1-4.127-5.162 4.633 4.633 0 0 1 4.4-4.6 20.22 20.22 0 0 1 2.852-.054q47.43.005 94.87.006z",
    className: "cls-3",
    transform: "translate(-1012.197 -996.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    d: "M1129.755 1257.973c-11.212 0-22.424.019-33.636-.014-3.453-.01-5.382-1.458-5.833-4.165a4.732 4.732 0 0 1 4.551-5.673q35.063-.127 70.127 0a4.76 4.76 0 0 1 4.656 5.034c-.086 2.73-2.144 4.752-5.277 4.781-8.99.083-17.981.037-26.973.041l-7.615-.004z",
    className: "cls-3",
    transform: "translate(-1024.081 -1070.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    d: "M1130.135 1159.011c11.319 0 22.638-.028 33.957.016 3.937.015 6.352 2.575 5.635 5.885a4.447 4.447 0 0 1-4.657 3.909c-13.3 0-26.594-.06-39.891-.054-4.014 0-8.028.207-12.042.2-6.121-.005-12.257.1-18.353-.326a5.567 5.567 0 0 1-3.912-3.3c-.411-1.379.5-3.638 1.586-4.826.878-.964 2.866-1.245 4.366-1.259 11.1-.1 22.208-.053 33.311-.053z",
    className: "cls-3",
    transform: "translate(-1024.32 -1032.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3206",
    d: "M1148.025 1203.647c9.172 0 18.344-.026 27.516.015 2.787.013 4.284 1.84 4.645 4.312.38 2.6-.964 4.484-3.552 5.248a8.977 8.977 0 0 1-2.5.262c-17.654.014-35.308.084-52.959-.1a7.381 7.381 0 0 1-5.278-2.512c-2.32-3.284.313-7.274 4.6-7.295 8.547-.04 17.095.054 25.642.093h1.894z",
    className: "cls-3",
    transform: "translate(-1034.744 -1051.814)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetain4);
export default __webpack_public_path__ + "static/media/retain4.4ee78269fa7d750466e5d9cfd2ea0f8d.svg";
export { ForwardRef as ReactComponent };